export default function flatten(tree, key, collection) {
	if (!tree[key] || tree.length === 0) return;

	for (let i = 0; i < tree[key].length; ++i) {
		const child = tree[key][i];
		collection.push(child);
		flatten(child, key, collection);
	}
}
